import { registerSW } from 'virtual:pwa-register';

// The service worker is registered at startup (login screen included) so the shell is cached from the first
// visit. A new build waits: `needRefresh` flips and the top bar offers Reload.
let needRefresh = false;
const subs = new Set();
let update = () => Promise.resolve();

export function startServiceWorker() {
  if (!('serviceWorker' in navigator)) return;
  update = registerSW({
    immediate: true,
    onNeedRefresh() { needRefresh = true; subs.forEach((fn) => fn(true)); },
    onRegisteredSW(_url, reg) { if (reg) setInterval(() => reg.update().catch(() => {}), 30 * 60000); },
  });
}

export const onNeedRefresh = (fn) => { subs.add(fn); fn(needRefresh); return () => subs.delete(fn); };
export const reloadToNewVersion = () => update(true);
